import translator from "../../../../components/localization/translator";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import React from "react";
import moment from "moment";

const POS_TYPE_MAP = {
    1: "HARD",
    2: "SOFT",
};

const renderPosTransactionDate = (_, row) => {
    const value = row?.transactionDate || row?.transaction_date;
    return value ? moment(value).format("DD.MM.YYYY HH:mm") : "";
};

const renderPosTransactionAuthCode = (_, row) =>
    row?.authCode || row?.auth_code || "";

const renderPosTransactionAmount = (_, row) => {
    const value = row?.amount;
    if (value == null || isNaN(value)) return "";
    return `${new Intl.NumberFormat("en-EN").format(Number(value))} ֏`;
};

const renderPosTransactionPosType = (_, row) => {
    const rawValue = row?.posType ?? row?.pos_type;

    if (rawValue == null) return "";

    return POS_TYPE_MAP[rawValue] || String(rawValue);
};

const PosTransactionsTable = ({ data }) => {
    if (!data?.length) {
        return (
            <div>
                {translator.translate("_pos_transactions_not_found_")}
            </div>
        );
    }

    return (
        <BootstrapTable data={data} striped hover>
            <TableHeaderColumn isKey dataField="_id" hidden>
                _id
            </TableHeaderColumn>

            <TableHeaderColumn
                dataField="transaction_date"
                dataFormat={renderPosTransactionDate}
                width="180px"
            >
                {translator.translate("_pos_transaction_date_")}
            </TableHeaderColumn>

            <TableHeaderColumn
                dataField="auth_code"
                dataFormat={renderPosTransactionAuthCode}
                width="160px"
            >
                {translator.translate("_pos_auth_code_")}
            </TableHeaderColumn>

            <TableHeaderColumn
                dataField="amount"
                dataFormat={renderPosTransactionAmount}
                width="200px"
            >
                {translator.translate("_pos_transaction_amount_amd_")}
            </TableHeaderColumn>

            <TableHeaderColumn
                dataField="pos_type"
                dataFormat={renderPosTransactionPosType}
                width="120px"
            >
                {translator.translate("_pos_type_")}
            </TableHeaderColumn>
        </BootstrapTable>
    );
};

export default PosTransactionsTable;
